import React from 'react'
import dompurify from 'dompurify';
import { VoteCategories } from '../../types/voteTypes';

export const MultiGroupVoteSummary = ({ groups, groupVotes }) => {
    // Get summary
    const getGroupSummary = (group, groupVotes) => {
        if (!groupVotes || groupVotes.length === 0) {
            return <div className="italic mb-2">Skipped</div>
        }

        if ([VoteCategories.BallotSingle, VoteCategories.BallotMulti, VoteCategories.SwimmingAustraliaResolution].includes(group.groupType)) {
            return [...groupVotes].sort((a, b) => a.ballotOptionId > b.ballotOptionId).map((vote) => {
                return <div key={vote.ballotOptionId} className="mb-2">{vote.ballotOptionName}</div>
            })
        }
        else if (group.groupType.startsWith("Ranked") || group.groupType === VoteCategories.SwimmingAustraliaDirectors) {
            return [...groupVotes].sort((a, b) => a.score < b.score).map((vote) => {
                return <div key={vote.ballotOptionId} className="mb-2">{vote.score} - {vote.ballotOptionName}</div>
            })
        }
        else if (group.groupType === VoteCategories.Questionnaire) {
            return [...groupVotes].sort((a, b) => a.ballotOptionId > b.ballotOptionId).map((vote) => {
                return <div key={vote.ballotOptionId} className="mb-2">{vote.score === 1 ? "Yes" : "No"} - {vote.ballotOptionName}</div>
            })
        }
        else if ([VoteCategories.Survey, VoteCategories.AGMMotion].includes(group.groupType)) {
            return [...groupVotes].sort((a, b) => a.ballotOptionId > b.ballotOptionId).map((vote) => {
                return (vote.textValue.startsWith("data:image") ?
                    <div key={vote.ballotOptionId}>
                        <div className="mb-2" dangerouslySetInnerHTML={{ __html: dompurify.sanitize(vote.ballotOptionName) }} />
                        <img src={vote.textValue} alt="" />
                    </div>
                    :
                    <div key={vote.ballotOptionId} className="mb-2" dangerouslySetInnerHTML={{ __html: dompurify.sanitize(vote.ballotOptionName + " - " + vote.textValue) }} />
                )
            })
        }

        return <div />
    }

    return (
        < React.Fragment >
            <div className="mb-4">A summary of your selections are displayed below.</div>
            {groupVotes && groups && Array.from(Object
                .keys(groups))
                .sort((a, b) => groups[a].order - groups[b].order)
                .map((groupId) => {
                    return (
                        <React.Fragment key={groupId}>
                            <div className="font-medium mb-4">{groups[groupId].groupName}</div>
                            {getGroupSummary(groups[groupId], groupVotes[groupId])}
                        </React.Fragment>
                    )
                })}
        </React.Fragment>
    )
}